<script setup lang="ts">
import type { ComponentBrandInfosProps } from "./ComponentBrandInfos.props"
const props = defineProps<ComponentBrandInfosProps>()
</script>

<template>
  <div class="cms-brand-infos grid-container mb-6 md:mb-14">
    <ProductBlocksBrandsUtilsInfo
      class="col-span-full md:col-span-12"
      v-if="props"
      v-bind="props"
    />
  </div>
</template>
